// extracted by mini-css-extract-plugin
export default {"hr-text":"FeaturedOccasion_hr-text__ErmvR"};